import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { toast } from 'react-toastify';
import apiConfig from 'constants/apiConfig';
import { keys } from 'hooks/incident/useRoster';
import { workLogKeys } from 'hooks/incident/useWorkLog';
import { parseError } from 'utils/parseTypedErrorMessage';

interface UpdateMemberActivationParams {
  incident_id: string;
  member_user_guid: string;
  is_activated: boolean;
  decline_note?: string;
}

export const useUpdateMemberActivation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UpdateMemberActivationParams) => {
      const response = await axios.post(
        apiConfig.apiGateway.updateMemberActivation,
        params
      );
      return response.data;
    },
    onSuccess: (data, variables) => {
      // Invalidate the roster query to refresh the data
      queryClient.invalidateQueries({
        queryKey: [keys.incidentRoster, variables.incident_id],
      });

      // Invalidate worklog queries to refresh activation status
      queryClient.invalidateQueries({
        queryKey: workLogKeys.byIncident(variables.incident_id),
      });

      if (variables.is_activated) {
        toast.success('Member activation confirmed');
      } else {
        toast.success('Member activation declined');
      }
    },
    onError: (error: unknown) => {
      toast.error(parseError(error) ?? 'Failed to update activation status');
    },
  });
};
